var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"variant":_vm.buildStatus.type}},[_vm._v(_vm._s(_vm.buildStatus.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }